// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"d4ec622f","378":"4a29a376"}[chunkId] + ".chunk.js";
};